/**
 * Metrics whose `rate` values are candidate evaluation scores, eligible for
 * rendering on the org's evaluation rating scale (see
 * `ReportDashboardMetricOptions.ratingScale`).
 */
export const SCORE_METRIC_IDS: readonly string[] = ['candidate_score'];

export const isScoreMetric = (metric: string): boolean => SCORE_METRIC_IDS.includes(metric);
